export const BRAND_IDS = {
  GAMERSFY_APP: 1,
  GAMERSFY_WEB: 2,
  COLISEUM: 3,
  WINDER: 4,
};
